import { useContext, useRef, useState } from "react";
import { FaBackspace, FaSearch } from "react-icons/fa";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";
import useAxios from "../common/hook/useAxios";
import Dropdown from "./Dropdown";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { IoArrowBackCircle } from "react-icons/io5";
const searchPatientType = [
    {
        value: "0",
        label: "Name",
    },
    {
        value: "1",
        label: "Phone",
    },
    {
        value: "2",
        label: "MRN",
    },
];
const DEBOUNCE_DELAY = 300;
const SearchPatientHeader = () => {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate()
      const debounceRef = useRef(null);
    const { request } = useAxios();
    const [inputValue, setInputValue] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [option, setOption] = useState("0");
    // const handleInputChange = async (e) => {
    //     const value = e.target.value?.trim()?.toLowerCase();
    //     setInputValue(value);
    //     const searchedPatient = await searchPatients(value);
    //     if (value) {
    //         // const filteredSuggestions = searchedPatient?.filter(
    //         //     (item) =>
    //         //         item.FirstName?.toLowerCase()?.includes(value) ||
    //         //         item.LastName?.toLowerCase()?.includes(value),
    //         // );
    //         setSuggestions(searchedPatient);
    //     } else {
    //         setSuggestions([]);
    //     }
    // };
   const handleInputChange = (e) => {
    let value = e.target.value;

    if (option === 1) {
      // Format as US phone number
      value = value.replace(/\D/g, "").slice(0, 10); // Keep only digits, max 10
      if (value.length <= 3) {
        value = value;
      } else if (value.length <= 6) {
        value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
      } else {
        value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`;
      }
    }

    setInputValue(value);

    // Clear existing debounce
    if (debounceRef.current) clearTimeout(debounceRef.current);

    // Debounced search
    debounceRef.current = setTimeout(async () => {
      let searchValue;

      if (option === 1) {
        searchValue = value.replace(/\D/g, ""); // pure digits for search
        if (searchValue.length === 0) return setSuggestions([]);
      } else {
        searchValue = value.trim().toLowerCase();
        if (!searchValue) return setSuggestions([]);
      }

      const searchedPatient = await searchPatients(searchValue);
      setSuggestions(searchedPatient);
    }, DEBOUNCE_DELAY);
  };
    const searchPatients = async (inputVal) => {
        // console.log(inputVal);

        const url = `${process.env.REACT_APP_ORDER_CODE_URL}/Search/SearchPracticePatients?sJSONInput={"PracticeID":"${user?.PracticeID}","SearchKey":"${inputVal}","SearchBy":${option},"isFromLogin":0}`;
        try {
            const res = await request({
                url,
                method: "GET",
            });
            //   setSearchPatient(res.Data);
            return res.Data;
        } catch (err) {
            console.log(err);
            // toast.error("Error occurred while searching patients", {
            //     autoClose: 3000,
            // });
            return [];
        }
    };
    const handleSuggestionClick = async (suggestion) => {
        console.log(suggestion);
        
        if (suggestion) {
            navigate(`/patient-dashboard?patientId=${suggestion?.PatientID}&patientName=${suggestion?.FirstName + suggestion?.LastName}`)
        }

    };
    return (
        <div className="bg-[#005d97] flex flex-row items-center justify-between">
            <IoArrowBackCircle className="text-white text-4xl pl-3" onClick={() => navigate(-1)} />
            <div className="text-white flex flex-row">
                <Dropdown
                    items={searchPatientType}
                    label={"Search By:"}
                    setSelectedValue={setOption}
                    isHeader={true}
                />
                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r text-gray-800">
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Add Patient"
                            value={inputValue}
                            onChange={handleInputChange}
                            className="pl-8 pr-4 py-2 border rounded-md w-full hide-on-print"
                        />
                        <FaSearch className="absolute top-1/2 left-2 transform -translate-y-1/2 text-gray-500" />
                        {suggestions?.length > 0 && (
                            <ul className="absolute top-full left-0 w-full bg-white border border-gray-300 mt-1 max-h-60 overflow-auto z-10">
                                {suggestions?.map((suggestion) => (
                                    <li
                                        key={suggestion.id}
                                        style={{ whiteSpace: "nowrap" }}
                                        className="p-2 cursor-pointer hover:bg-gray-200"
                                        onClick={() => handleSuggestionClick(suggestion)}
                                    >
                                        {suggestion.LastName}, {suggestion.FirstName}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </td>
            </div>
        </div>
    );
};

export default SearchPatientHeader;
